// extracted by mini-css-extract-plugin
module.exports = {"container":"_2UA7c","boxWrapper":"_1y6-4"};